import { Card, CardContent } from "@material-ui/core";
import styles from "../../../styles/styles";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from "@material-ui/core";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { strings } from "../../../lib/strings";

const AgentHomeScreenReminder = () => {
  return (
    <Card style={styles.homeScreenReminder}>
      <CardContent>
        <Typography gutterBottom variant="body1">
          <List>
            {strings.reminders.map((item) => (
              <ListItem>
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary={item} disableTypography={true} />
              </ListItem>
            ))}
          </List>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default AgentHomeScreenReminder;
